<template>
  <div>
    <base-card v-if="targetItem.sizes.filter((i) => !i.delete).length > 0">
      <base-question
        :text="
          targetItem.sizes.length > 1
            ? 'Quais são os tamanhos?'
            : targetItem.mode === 'pizza'
            ? 'Informe o máximo de sabores:'
            : 'Qual é o tamanho?'
        "
        class="mb_20"
      />

      <div v-if="targetItem.mode !== 'drink'">
        <div v-if="targetItem.sizes.length > 0">
          <div v-for="size in targetItem.sizes" :key="size._id">
            <div v-if="!size.delete" class="size-container">
              <base-input
                label="Nome do tamanho"
                v-if="targetItem.sizes.length > 1"
                v-model="size.name"
                class="mb_0 pr_5 pt_0 size-item mr_10"
                v-on:change="applyValue(size._id, 'name', size.name)"
                :valid="!emptyNameError[size._id]"
              />

              <base-input
                v-if="targetItem.mode === 'pizza'"
                label="Max. sabores"
                v-model="size.max"
                :type="'number'"
                class="mb_0 pt_0 mr_10"
                :class="
                  targetItem.mode === 'pizza' && targetItem.sizes.length === 1
                    ? 'size-item'
                    : 'size-item--small'
                "
                v-on:change="applyValue(size._id, 'max', size.max)"
                :valid="
                  (targetItem.sizes.length === 1 &&
                    !emptyMaxFlavorError.oneSize) ||
                  (targetItem.sizes.length > 1 &&
                    !emptyMaxFlavorError.manySizes[size._id])
                "
              />

              <base-button
                v-if="targetItem.sizes.length > 1"
                :text="StringLanguage.delete"
                design="four"
                @click.prevent="deleteItem(size._id)"
                class="delete-button"
              >
                <i class="fal fa-times"></i>
              </base-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="targetItem.sizes.length > 0">
          <diV v-for="(size, elementIndex) in targetItem.sizes" :key="size._id">
            <div
              v-if="!size.delete"
              :class="elementIndex > 0 ? 'size-with-border' : ''"
            >
              <div class="size-container">
                <base-select
                  class="size-item"
                  title="Tipo da embalagem"
                  placeholder="Tipo da embalagem"
                  v-model="size.package"
                  v-on:change="applyValue(size._id, 'package', size.package)"
                  :valid="!emptyValidSizes.oneSize"
                >
                  <option :value="null" :selected="true">
                    Selecione uma embalagem
                  </option>
                  <option
                    v-for="(packageType, i) in availablePackages"
                    :key="`package-${i}`"
                    :value="packageType"
                    :selected="size.package == packageType"
                  >
                    {{ PackageNames[packageType] }}
                  </option>
                </base-select>
                <base-button
                  v-if="targetItem.sizes.length > 1"
                  :text="StringLanguage.delete"
                  design="four"
                  @click.prevent="deleteItem(size._id)"
                  class="delete-button mt_10"
                >
                  <i class="fal fa-times"></i>
                </base-button>
              </div>
              <div class="size-container">
                <base-input
                  class="size-item mr_15"
                  label="Volume"
                  :type="'number'"
                  v-model="size.amount"
                  v-on:change="applyValue(size._id, 'amount', size.amount)"
                  :valid="!emptyValidSizes.oneSize"
                />
                <base-select
                  class="size-item"
                  title="Medida"
                  placeholder="Medida"
                  v-model="size.unit"
                  v-on:change="applyValue(size._id, 'unit', size.unit)"
                  :valid="!emptyValidSizes.oneSize"
                >
                  <option :value="null" :selected="true">
                    Selecione uma medida
                  </option>
                  <option
                    v-for="(unit, i) in availableUnits"
                    :key="`unit-${i}`"
                    :value="unit"
                    :selected="size.unit == unit"
                  >
                    {{ unit }}
                  </option>
                </base-select>
              </div>
            </div>
          </diV>
        </div>
      </div>
      <div class="d-flex justify-end w-100 mt_25">
        <base-button
          v-if="targetItem.sizes.length > 1"
          :text="
            targetItem.mode !== 'drink'
              ? StringLanguage.add
              : 'Adicionar tamanho'
          "
          design="two"
          @click.prevent="addSize()"
          class="w-100 mr_5"
        />
      </div>
    </base-card>
  </div>
</template>

<script>
// components
import BaseCard from '@/components/Card';
import BaseQuestion from '@/components/Question';
import BaseInput from '@/components/Input';
import BaseButton from '@/components/Button';
import BaseSelect from '@/components/Select';
// libs
import Vue from 'vue';
import {
  PackageType,
  PackageNames,
} from 'easyjs/lib/Schema/Components/PackageType';
import { VolumeUnit } from 'easyjs/lib/Schema/Components/Unit';
import Builder from 'easyjs/lib/Schema/Components/Builder';

export default {
  components: {
    BaseCard,
    BaseQuestion,
    BaseInput,
    BaseButton,
    BaseSelect,
  },
  data() {
    return {
      emptyNameError: {},
      emptyMaxFlavorError: {
        oneSize: false,
        manySizes: {},
      },
      emptyValidSizes: {
        oneSize: false,
      },
      PackageNames,
      availablePackages: [
        PackageType.COPO,
        PackageType.GALAO,
        PackageType.GARRAFA,
        PackageType.JARRA,
        PackageType.LATA,
        PackageType.LONGNECK,
        PackageType.OTHER,
      ],
      availableUnits: [VolumeUnit.mL, VolumeUnit.L],
    };
  },
  props: {
    targetItem: { default: {} },
  },
  methods: {
    addSize() {
      this.addNewItem('Size', this.targetItem._id);
      this.updateItems();
      if (this.targetItem.new == false) {
        alert(
          'Tamanho adicionado com sucesso, configure os valores em cada produto.'
        );
      }
    },
    addNewItem(type, target, node) {
      let item = (node || this.targetItem).getItemsByParam('_id', target)[0];
      let newItem = Builder.factory(type);
      newItem.new = true;
      newItem._id = Builder.generateRandomId('_');
      newItem.parent = item._id;
      item.addItems(newItem);
      return newItem;
    },
    updateItems() {
      this.targetItem.items.forEach((e) => {
        let itemSizes = e.sizes.reduce(
          (obj, size) => ({ ...obj, [size._id]: size }),
          {}
        );
        e.sizes = this.targetItem.sizes
          .map((s) => {
            return itemSizes[s._id] || Builder.mountSchema(Object.clone(s));
          })
          .filter((s) => !s.delete);
      });
    },
    deleteItem(id = null, showConfirm = true) {
      if (id) {
        const deleteFn = () => {
          this.targetItem
            .getItemsByParam('_id', id)
            .forEach((i) => Vue.set(i, 'delete', true));
          //Remove todos os tamanhos que foram excluídos
          let catalog = Builder.factory('Catalog');
          catalog.addItems(this.targetItem);
          Builder.executeOnSchema(catalog, (item) => {
            if (item.sizes.length > 0) {
              Vue.set(
                item,
                'sizes',
                item.sizes.filter((s) => !s.delete)
              );
            }
          });
        };

        if (showConfirm) {
          if (this.targetItem.sizes.length > 2) {
            confirm(StringLanguage.confirmDelete, (res) => res && deleteFn());
          } else {
            alert('A categoria deve ter ao menos 2 tamanhos');
          }
        } else {
          deleteFn();
        }
      } else {
        this.targetItem.delete = true;
        this.$emit('saveItem', this.targetItem);
      }
    },
    applyValue(_id, key, value) {
      this.targetItem.getItemsByParam('_id', _id).forEach((i) => {
        Vue.set(i, key, value);
        if (i.type == 'size' && this.targetItem.mode === 'drink') {
          Vue.set(
            i,
            'name',
            `${PackageNames[i.package]} (${i.amount} ${i.unit})`
          );
        }
      });
    },
    isValidField(key, value) {},
  },
};
</script>

<style scoped>
.size-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}
.size-item {
  flex: 1;
}
.size-item--small {
  flex: 0.5;
}
.delete-button {
  height: 45px;
  margin-left: 5px;
  border-color: #99999980;
}
.delete-button i {
  font-size: 16px;
}
.size-with-border {
  border-top: 2px solid #777777 !important;
  margin-top: 25px;
  padding-top: 25px;
}
@media screen and (max-width: 768px) {
  .size-item {
    flex: 0.8;
  }
  .size-item--small {
    flex: 0.6;
  }
}
</style>
